export const LABELS = {
  issueBodyHeader: 'Description',
  issueBodyPlaceholder: 'Type your description here…',
  issueBodyHeaderActions: 'Issue body actions',
}
